// extracted by mini-css-extract-plugin
export default {"container":"UploadImage_container__kQa34","title":"UploadImage_title__QTw7n","btnText":"UploadImage_btnText__Hh6zL"};